import { mapState } from 'vuex';
export default {
  name: 'navUser',
  data() {
    return {};
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  methods: {
    async logout() {
      await this.$store.dispatch('user/logout');
      await this.$store.dispatch('tagsView/clearTag');
      // 清除所有 sessionStorage，防止有脏数据残留
      if (window && window.sessionStorage) {
        window.sessionStorage.clear();
      }
      this.$router.replace({
        path: '/login'
      });
    }
  }
};